import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1c1c1c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M11.827.6v19M.6 10.1h22.454M5.35 16.145a5.613 5.613 0 0 0 5.613-5.613V10.1m7.341 6.045a5.614 5.614 0 0 1-5.613-5.613V10.1m-2.277-5.032c1.623 1.622 1.22 4.885 1.22 4.885s-3.262.4-4.883-1.222a2.591 2.591 0 0 1 3.664-3.664M2.327 19.6h19a1.727 1.727 0 0 0 1.727-1.727V2.327A1.727 1.727 0 0 0 21.327.6h-19A1.727 1.727 0 0 0 .6 2.327v15.546A1.727 1.727 0 0 0 2.327 19.6M16.86 8.73c-1.622 1.623-4.885 1.221-4.885 1.221s-.402-3.262 1.221-4.884A2.591 2.591 0 0 1 16.86 8.73"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "gift"}) } }